import React, { useEffect, useState } from 'react';

const WidgetPreviewDisplay = () => {
    const [backgroundImage, setBackgroundImage] = useState(null);

    useEffect(() => {
        // Get background image from sessionStorage
        const storedImage = sessionStorage.getItem('widget_preview_background');
        if (storedImage) {
            setBackgroundImage(storedImage);

            // Get image dimensions
            const img = new Image();
            img.onload = () => {
                console.log(`Preview image loaded: ${img.naturalWidth}x${img.naturalHeight}`);
            };
            img.src = storedImage;
        }

        // Load widget script
        const loadWidget = () => {
            // First, load the widget.js script
            const script = document.createElement('script');
            script.src = '/widget.js';
            script.async = true;

            script.onload = () => {
                console.log('Widget script loaded');

                // Wait a bit for the script to initialize, then configure it
                setTimeout(() => {
                    if (window.ChatWidget) {
                        const backendUrl = process.env.REACT_APP_API_BASE_URL?.replace('/api', '');
                        const activeAgentId = localStorage.getItem('activeAgentId') || '00000000-0000-0000-0000-000000000002';

                        // Retrieve the synced configuration from sessionStorage
                        const syncedConfigJson = sessionStorage.getItem('widget_preview_config');
                        const syncedConfig = syncedConfigJson ? JSON.parse(syncedConfigJson) : {};

                        // Initialize the widget with configuration
                        window.ChatWidget.init({
                            apiUrl: backendUrl,
                            agentId: activeAgentId,
                            isPreview: true,
                            ...syncedConfig // Spread current UI settings (colors, toggles, etc.)
                        });

                        console.log(`Widget initialized for agent ${activeAgentId}`);
                    } else {
                        console.error('ChatWidget not found on window object');
                    }
                }, 500);
            };

            script.onerror = () => {
                console.error('Failed to load widget script');
            };

            document.body.appendChild(script);
        };

        loadWidget();

        // Cleanup
        return () => {
            // Remove widget elements if they exist
            const widgetContainer = document.querySelector('.chat-widget-container');
            if (widgetContainer) {
                widgetContainer.remove();
            }
        };
    }, []);

    return (
        <div 
            className="w-screen h-screen m-0 p-0 overflow-hidden relative"
            style={{
                backgroundColor: backgroundImage ? 'transparent' : '#ffffff',
                backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}
        >
            {/* If no background image, show a subtle pattern */}
            {!backgroundImage && (
                <div 
                    className="absolute inset-0 opacity-50 z-0"
                    style={{
                        background: 'linear-gradient(45deg, #f8f9fa 25%, transparent 25%, transparent 75%, #f8f9fa 75%, #f8f9fa), linear-gradient(45deg, #f8f9fa 25%, transparent 25%, transparent 75%, #f8f9fa 75%, #f8f9fa)',
                        backgroundSize: '60px 60px',
                        backgroundPosition: '0 0, 30px 30px'
                    }}
                />
            )}

            {/* Empty container for widget placement if no background is provided */}
            {!backgroundImage && (
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <div className="text-gray-300 text-sm font-medium uppercase tracking-widest opacity-20">
                        Widget Preview Mode
                    </div>
                </div>
            )}
        </div>
    );
};

export default WidgetPreviewDisplay;
